import { lazy } from "react"

const Other = [
  {
    path: "/not-authorized",
    component: lazy(() => import("@views/other/NotAuthorized")),
    layout: "BlankLayout",
    meta: {
      publicRoute: true
    }
  },
  {
    path: "/error",
    component: lazy(() => import("@views/other/Error")),
    layout: "BlankLayout",
    meta: {
      publicRoute: true
    }
  }
]

export default Other
